/**
 * Corps de l'événement CHAT_MESSAGE envoyé par le front, ou `null` quand live-api a accepté le
 * message : le consumer produit alors l'événement lui-même, un second envoi compterait deux fois.
 */
export function chatMessageAnalyticsPayload(
  posted: { id?: number | string | null } | null,
): string | null {
  if (!posted) return null;
  return JSON.stringify({ messageId: posted.id?.toString() });
}
